import script from "./app-group-export-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./app-group-export-modal.vue?vue&type=script&setup=true&lang=js"

import "./app-group-export-modal.vue?vue&type=style&index=0&id=12547d18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12547d18"]])

export default __exports__